<template>
    <div class="report">
        <q-scroll-area ref="scrollAreaRef" visible style="height: 100%">
            <div class="bg_color_gray_100">
                <div class="top__info b1">
                    <div class="top__info__wrap">
                        <div>
                            <div>
                                <div class="mg_bottom_16 b1 color_gray_800">{{ comSchoolAndGrade }}</div>
                                <div class="report__title">
                                    <b
                                        >{{ globalStore.userInfo.studentName }}님의<br />예측 등급은<br />
                                        <span class="color_primary bold"> {{ summaryData?.grade }}등급 입니다!</span></b
                                    >
                                </div>
                            </div>
                            <div class="report__calendar"><q-icon name="img:/assets/images/icon/ico_report_calender.svg" class="mg_right_16" style="width: 2.1vw; height: 2.1vw" /> {{ summaryData?.issueDate }}</div>
                        </div>
                        <div>
                            <div class="chart__wrap">
                                <div class="chart__item">
                                    <div class="chart__area">
                                        <!-- <GaugeChart v-if="summaryData?.totalAccuracyRate" :chartData="summaryData?.totalAccuracyRate" /> -->
                                        <GaugeChart v-if="summaryData?.grade" :chartData="9 - summaryData?.grade" :label="summaryData?.grade" :endData="8" unit="등급" />
                                        <!-- <GaugeChart v-if="summaryData?.grade" :chartData="9 - 5" :label="5" :endData="8" unit="등급" /> -->
                                        <!-- <GaugeChart v-if="summaryData?.grade" :chartData="10 - 1" :label="1" :endData="9" unit="등급" /> -->
                                    </div>
                                    <div class="chart__summary">
                                        <div>
                                            <div class="b1 line_height_45" style="font-weight: bold">예측등급</div>
                                            <div class="h3 color_black bold">
                                                등급 <span class="color_primary bold">{{ summaryData?.grade }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pd_lr_230">
                <div class="title mg_top_46">수능모의평가 결과</div>
                <div>
                    <div class="row justify-between b3">
                        <div class="summary_box">
                            <div>
                                <div class="medium">점수</div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">{{ summaryData?.point }}</span
                                    >/100 <span class="b2 bold" style="font-size: 2.4vmin">점</span>
                                </div>
                            </div>
                            <div style="margin: 1.66vmin 0px; display: flex; align-items: center">
                                <q-icon name="img:/assets/images/icon/img_archer.png" size="10vmin" />
                            </div>
                        </div>
                        <div class="summary_box">
                            <div>
                                <div class="medium">맞힌 문항수</div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">{{ summaryData?.correctCount }}</span
                                    >/34 <span class="b2 bold" style="font-size: 2.4vmin">문항</span>
                                </div>
                            </div>
                            <div style="margin: 1.66vmin 0px; display: flex; align-items: center">
                                <q-icon name="img:/assets/images/icon/ico_Good.png" size="10vmin" />
                            </div>
                        </div>
                        <div class="summary_box">
                            <div>
                                <div class="medium">소요 시간</div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">
                                        <!-- {{ summaryData?.elapsedMinute }} -->
                                        <template v-if="summaryData?.elapsedHour !== 0"> {{ summaryData?.elapsedHour }}<span class="b2 bold" style="font-size: 2vmin">시간 </span> </template>
                                        <template v-if="summaryData?.elapsedMinute !== 0"> {{ summaryData?.elapsedMinute }}<span class="b2 bold" style="font-size: 2vmin">분 </span> </template>
                                        <template v-if="summaryData?.elapsedSecond !== 0"> {{ summaryData?.elapsedSecond }}<span class="b2 bold" style="font-size: 2vmin">초</span> </template> </span
                                    >/60 <span class="b2 bold" style="font-size: 2.4vmin">분</span>
                                </div>
                            </div>
                            <div style="margin: 1.66vmin 0px; display: flex; align-items: center">
                                <q-icon name="img:/assets/images/icon/ico_clock_green.png" size="10vmin" />
                            </div>
                        </div>
                    </div>
                    <div class="final__comment bold">
                        {{ summaryData?.satComment }}
                    </div>
                </div>
            </div>
            <div class="hr" />
            <div class="pd_lr_230">
                <div class="title mg_top_72">지문 분석</div>
                <q-markup-table flat class="summary-table">
                    <thead>
                        <tr>
                            <th class="text-center">영역</th>
                            <th class="text-center">번호</th>
                            <th class="text-center">갈래/주제</th>
                            <th class="text-center">지문</th>
                            <th class="text-center">KReaD</th>
                            <th class="text-center">글자수</th>
                            <th class="text-center">정답률</th>
                            <th class="text-center">목표시간</th>
                            <th class="text-center">풀이시간</th>
                        </tr>
                    </thead>
                    <tbody v-if="passageList">
                        <tr v-for="(vData, index) in Object.values(passageList?.passageResultListN)">
                            <td v-if="index === 0" class="text-center" :rowspan="passageList?.passageResultListN.length">비문학</td>
                            <td class="text-center">{{ vData?.firstNo }} ~ {{ vData?.lastNo }}</td>
                            <td class="text-center">
                                {{ vData?.topic }}
                            </td>
                            <td class="text-center">
                                {{ vData?.passageName }}
                            </td>
                            <td class="text-center">
                                {{ vData?.kreadScore }}
                            </td>
                            <td class="text-center">
                                {{ vData?.bookDesc }}
                            </td>
                            <td class="text-center" :style="Number(vData?.correctRate) < 50 ? 'color:#EF2B2A;' : ''">{{ vData?.correctRate }}%</td>
                            <td class="text-center">
                                {{ vData?.solveTime && getTimeStringSecondsKor(vData?.solveTime) }}
                            </td>
                            <td class="text-center" :style="vData?.solveTime < vData?.elapsedTime ? 'color:#EF2B2A;' : ''">
                                {{ vData?.elapsedTime && getTimeStringSecondsKor(vData?.elapsedTime) }}
                            </td>
                        </tr>
                        <tr v-for="(vData, index) in Object.values(passageList?.passageResultListL)">
                            <td v-if="index === 0" class="text-center" :rowspan="passageList?.passageResultListL.length">문학</td>
                            <td class="text-center">{{ vData?.firstNo }} ~ {{ vData?.lastNo }}</td>
                            <td class="text-center">
                                {{ vData?.topic }}
                            </td>
                            <td class="text-center">
                                {{ vData?.passageName }}
                            </td>
                            <td class="text-center">
                                {{ vData?.kreadScore }}
                            </td>
                            <td class="text-center">
                                {{ vData?.bookDesc }}
                            </td>
                            <td class="text-center" :style="Number(vData?.correctRate) < 50 ? 'color:#EF2B2A;' : ''">{{ vData?.correctRate }}%</td>
                            <td class="text-center">
                                {{ vData?.solveTime && getTimeStringSecondsKor(vData?.solveTime) }}
                            </td>
                            <td class="text-center" :style="vData?.solveTime < vData?.elapsedTime ? 'color:#EF2B2A;' : ''">
                                {{ vData?.elapsedTime && getTimeStringSecondsKor(vData?.elapsedTime) }}
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </div>
            <div class="pd_lr_230">
                <div class="title mg_top_72">문항 분석</div>
                <div class="title__sub">
                    <div style="width: 8px; height: 8px; border-radius: 4px; background: black; margin-right: 0.8vw"></div>
                    <div>사고 유형별 강약점</div>
                    <Help class="question-mark">
                        <div class="pd_left_20">
                            <ul class="mark__list">
                                <li style="list-style: disc">사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력</li>
                                <li style="list-style: disc">추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력</li>
                                <li style="list-style: disc">비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력</li>
                                <li style="list-style: disc">감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력</li>
                                <li style="list-style: disc">개념 : 개념을 적용하여 글을 이해하고 판단하는 능력</li>
                                <li style="list-style: disc">어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력</li>
                            </ul>
                        </div>
                    </Help>
                </div>
                <div class="colum__chart__wrap">
                    <!-- <div class="answer__box">
                        <div class="answer__box__wrap">
                            <div class="answer__box__legend"></div>
                            <div class="medium">내 정답률</div>
                        </div>
                    </div> -->
                    <columChart v-if="analysisChartData.length > 0" :chartData="analysisChartData" />
                </div>

                <div class="title__sub">
                    <div style="width: 8px; height: 8px; border-radius: 4px; background: black; margin-right: 0.8vw"></div>
                    <div>질문 유형별 강약점</div>
                </div>

                <div class="colum__chart__wrap">
                    <!-- <div class="answer__box">
                        <div class="answer__box__wrap">
                            <div class="answer__box__legend"></div>
                            <div class="medium">내 정답률</div>
                        </div>
                    </div> -->
                    <columChart v-if="problemTypeChartData.length > 0" :chartData="problemTypeChartData" />
                </div>
            </div>
            <div class="pd_lr_230">
                <div class="title mg_top_72">문항별 풀이 결과</div>
                <q-markup-table flat class="summary-table">
                    <thead>
                        <tr>
                            <th class="text-center">영역</th>
                            <th class="text-center">번호</th>
                            <th class="text-center">사고 유형</th>
                            <th class="text-center">학습 개념 상세</th>
                            <th class="text-center">정답</th>
                            <th class="text-center">내답안</th>
                            <th class="text-center">정답여부</th>
                            <th class="text-center">풀이화면</th>
                        </tr>
                    </thead>
                    <tbody v-if="problemList">
                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListN)">
                            <td v-if="index === 0" class="text-center" :rowspan="problemList?.problemResultListN.length">비문학</td>
                            <td class="text-center">{{ vData?.problemOrd }}</td>
                            <td class="text-center">{{ vData?.analysisName }}</td>
                            <td class="text-center">{{ vData?.learningConceptName }}</td>
                            <td class="text-center">{{ vData?.correct }}</td>
                            <td class="text-center">{{ vData?.answer }}</td>
                            <td class="text-center">
                                <!-- <q-icon :name="vData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm"
                  :style="vData.correctYn === false ? 'color:#EF2B2A ;' : ''">
                </q-icon> -->
                                <q-icon :name="vData.correctYn === true ? 'img:/assets/images/icon/ic_ox_1.svg' : 'img:/assets/images/icon/ic_ox_3.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                            </td>
                            <td
                                class="text-center"
                                style="cursor: pointer"
                                :onClick="
                                    () => {
                                        onClickReview(vData?.answerHistorySeq, index + 1);
                                    }
                                "
                            >
                                <u>보기</u>
                            </td>
                        </tr>
                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListL)">
                            <td v-if="index === 0" class="text-center" :rowspan="problemList?.problemResultListL.length">문학</td>
                            <td class="text-center">{{ vData?.problemOrd }}</td>
                            <td class="text-center">{{ vData?.analysisName }}</td>
                            <td class="text-center">{{ vData?.learningConceptName }}</td>
                            <td class="text-center">{{ vData?.correct }}</td>
                            <td class="text-center">{{ vData?.answer }}</td>
                            <td class="text-center">
                                <!-- <q-icon :name="vData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm"
                  :style="vData.correctYn === false ? 'color:#EF2B2A ;' : ''">
                </q-icon> -->
                                <q-icon :name="vData.correctYn === true ? 'img:/assets/images/icon/ic_ox_1.svg' : 'img:/assets/images/icon/ic_ox_3.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                            </td>
                            <td
                                class="text-center"
                                style="cursor: pointer"
                                :onClick="
                                    () => {
                                        onClickReview(vData?.answerHistorySeq, index + 18);
                                    }
                                "
                            >
                                <u>보기</u>
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </div>
            <div style="text-align: center; margin: 6vmin 0" class="btn__wrap">
                <template v-if="!isListItem">
                    <!-- <CqBtn size="lg" unelevated label="다른 분석리포트 보러가기" @onClickFn="movePg('analysisreport')"
            style="margin-left: 10px; background-color: #FF4E7C; color:white " /> -->
                    <template v-if="globalStore.loginRoot === 'growthplate'">
                        <CqBtn class="btn" outline color="" label="다음 과목 선택" style="margin-left: 10px" @onClickFn="moveToGrowthplate('end')" />
                    </template>
                    <CqBtn class="btn" unelevated outline label="다음 학습" @onClickFn="studyStart" style="margin-right: 10px" />
                    <CqBtn class="btn" unelevated outline label="학습 홈" @onClickFn="movePg('learninghome')" />
                    <template v-if="globalStore.loginRoot === 'growthplate'">
                        <CqBtn class="btn" outline color="" label="오늘 학습 종료" style="margin-left: 10px" @onClickFn="moveToGrowthplate('selfcheck')" />
                    </template>
                </template>
                <template v-if="isListItem">
                    <CusButton
                        :type="462"
                        :label="`분석리포트 홈`"
                        @onReturn="
                            () => {
                                emit('close');
                            }
                        "
                    />
                    <!-- <CqBtn class="btn" outline color="" label="분석리포트 홈" @onClickFn="() => { emit('close'); }" /> -->
                </template>
            </div>
        </q-scroll-area>
    </div>
    <q-dialog v-model="reviewModal" persistent maximized>
        <!-- transition-show="slide-left" transition-hide="slide-right"
    > -->
        <Review v-if="reviewModal" :answerHistorySeq="answerHistorySeq" :num="answerNum" :numLeft="contentsNum"></Review>
    </q-dialog>
</template>

<script setup>
import { onMounted, ref, watch, computed, defineEmits, defineProps } from 'vue';
import CusButton from '@/components/widget/CusButton.vue';
import StudyHeader from '@/components/layouts/header/studyHeader.vue';
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { getUserJson, getUserMain, postUserJson, growthplateFinish } from '@/api/modules/login';
import * as zzApi from '@/api/modules/login';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { getReportSat, getReportReview } from '@/api/modules/study';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, timeStringSecondsKorToSec } from '@/helpers/utils';
import { useRouter } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { analysis, difficult, problemType, learningType } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';
import Help from '@/components/quasar/help.vue';
import Review from '../component/review.vue';
import { testData } from './test';
import columChart from '@/components/chart/columChart.vue';
import { DialogStore } from '@/store/modules/dialog';
import KreadChart from '@/components/chart/kreadChart.vue';
// import { requestGrowthplateLogout } from '@/helpers/common';
import Comm from '@/components/common.js';

const $q = useQuasar();
const coreProcess = ref(0.5);
const model = ref('1');
const user = ref(null);
const reviewModal = ref(false);
const answerHistorySeq = ref(null);

const contentsNum = ref(null);
const answerNum = ref(null);
const tab = ref('passage1');
const globalStore = GlobalStore();
const studyStore = StudyStore();
const summaryData = ref(null);
const passageList = ref(null);
const problemList = ref(null);
const analysisResult = ref({});
const analysisChartData = ref([]);
const problemTypeChartData = ref([]);
const router = useRouter();
const store = DialogStore();
const rsData = ref(null);

const props = defineProps({
    reportData: {
        default: null,
    },
    isListItem: { default: false },
});

const growthData = ref({
    systemId: '',
    sbjgrpId: '',
    sbjgrpSeq: '',
    kunnr: '',
    loginSeq: '',
    scenarioSeq: '',
    accessToken: '',
    scenarioLvlSeq: '',
    ustudyActSeq: '',
    zempId: '',
    matnrSeq: '',
    matnr: '',
    zProc: '',
    setNo: '',
});

const emit = defineEmits(['close']);

const onClickReview = (seq, num) => {
    // console.log(seq);
    answerHistorySeq.value = seq;
    answerNum.value = num;
    reviewModal.value = true;
    // getReportReview({ answerHistorySeq: seq }, (rs) => {
    //   console.log(rs);
    // })
    contentsNum.value = arrHeaderNo.value[num - 1];
};

const arrHeaderNo = ref([]);
const pushHeaderNo = (start, end) => {
    const result = `[${start}~${end}]`;
    for (let i = start - 1; i < end; i++) {
        arrHeaderNo.value.push(result);
    }
};
const setHeaderNo = (rs) => {
    rs.passageResultListN.forEach((e) => {
        // console.log('--passageResultListN-rs nnnn-', e.firstNo, e.lastNo);
        pushHeaderNo(e.firstNo, e.lastNo);
    });
    rs.passageResultListL.forEach((e) => {
        // console.log('--passageResultListL-rs e-', e.firstNo, e.lastNo);
        pushHeaderNo(e.firstNo, e.lastNo);
    });
    // console.log('--passageResultListN-rs arrHeaderNo-', arrHeaderNo.value);
};

const requestGrowthplateFinish = async () => {
    console.log('studyStore ===', studyStore);
    let learningHistorySeqArr = [];
    learningHistorySeqArr.push(studyStore?.report?.learningHistorySeq);
    let params = {
        learningHistorySeqs: learningHistorySeqArr,
        learningTypeCode: learningType[studyStore.process.exam.learningType].code,
    };
    console.log('requestGrowthplateFinish params ===', params);

    const response = await growthplateFinish(params);
    console.log('growthplateFinish API response ===', response);
    const resData = response?.data?.data;
    if (response?.data?.statusCode === '200') {
        growthData.value.systemId = resData?.systemId;
        growthData.value.sbjgrpId = resData?.sbjgrpId;
        growthData.value.sbjgrpSeq = resData?.sbjgrpSeq;
        growthData.value.kunnr = resData?.kunnr;
        growthData.value.loginSeq = resData?.loginSeq;
        growthData.value.scenarioSeq = resData?.scenarioSeq;
        growthData.value.accessToken = resData?.accessToken;
        growthData.value.scenarioLvlSeq = resData?.scenarioLvlSeq;
        growthData.value.ustudyActSeq = resData?.ustudyActSeq;
        growthData.value.zempId = resData?.zempId;
        growthData.value.matnrSeq = resData?.matnrSeq;
        growthData.value.matnr = resData?.matnr;
        growthData.value.zProc = resData?.zProc;
        growthData.value.setNo = resData?.setNo;
    }
};

const sendGrowthData = (type) => {
    const globalStore = GlobalStore();
    let dataToSend = {
        systemId: growthData.value.systemId,
        sbjgrpId: growthData.value.sbjgrpId,
        sbjgrpSeq: growthData.value.sbjgrpSeq,
        kunnr: encodeURI(growthData.value.kunnr),
        loginSeq: growthData.value.loginSeq,
        scenarioSeq: growthData.value.scenarioSeq,
        accessToken: encodeURI(growthData.value.accessToken),
        scenarioLvlSeq: growthData.value.scenarioLvlSeq,
        ustudyActSeq: growthData.value.ustudyActSeq,
        zempId: encodeURI(growthData.value.zempId),
        matnrSeq: growthData.value.matnrSeq,
        matnr: growthData.value.matnr,
        zProc: growthData.value.zProc,
        setNo: growthData.value.setNo,
        path: type === 'selfcheck' ? 'Important' : 'Main',
    };
    // const jsonStr = JSON.stringify(dataToSend);
    // console.log('jsonStr ===', jsonStr);
    //Growth.sendDataToAndroid(jsonStr);
    window.PanApp.sendErrToAndroid('Home');

    globalStore.setToken(null);
    globalStore.setReToken(null);
    globalStore.setAudience('');
    globalStore.setLogoutPath('');
};

const moveToGrowthplate = (type) => {
    console.log('moveToGrowthplate type', type);
    sendGrowthData(type);
};

onMounted(() => {
    // summaryData.value = {
    //   totalAccuracyRate: testData.totalAccuracyRate,
    //   coreResult: testData.totalLearningResult.coreResult,
    //   earnestResult: testData.totalLearningResult.earnestResult,
    //   vocabularyResult: testData.totalLearningResult.vocabularyResult,
    // }
    // passageList.value = testData.passageList
    // getReportSat({ learningHistorySeq: 760 }, (rs) => {
    if (props?.reportData) {
        // if (props.reportParams.learningHistorySeq) {
        // getReportSat({ learningHistorySeq: props.reportParams.learningHistorySeq }, (rs) => {
        const rs = props?.reportData;
        // console.log('--onMounted-rs-', rs);
        // console.log('--onMounted-rs-', props?.reportData.passageResultListL[0].firstNo);
        setHeaderNo(rs);
        // if (!props.reportParams.learningHistorySeq) {
        // console.log(rs);
        // const rs = testData;
        summaryData.value = {
            correctCount: rs.correctCount,
            point: rs.point,
            grade: rs.grade,
            point: rs.point,
            elapsedHour: rs.elapsedHour,
            elapsedMinute: rs.elapsedMinute,
            elapsedSecond: rs.elapsedSecond,
            satComment: rs.satComment,
            issueDate: rs.issueDate,
            schoolGrade: rs.schoolGrade,
        };
        passageList.value = { passageResultListL: rs.passageResultListL, passageResultListN: rs.passageResultListN };
        problemList.value = { problemResultListL: rs.problemResultListL, problemResultListN: rs.problemResultListN };
        // console.log(passageList);
        // console.log(problemList);
        let tmpChartData = [];

        Object.entries(analysis).forEach(([k, v]) => {
            if (rs.analysisResult['analysis' + k] > -1) {
                if (v.ord < 4) {
                    tmpChartData.push({
                        category: v.label + ' 독해',
                        value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                        ord: v.ord,
                    });
                } else {
                    tmpChartData.push({
                        category: v.label,
                        value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                        ord: v.ord,
                    });
                }
            }
        });
        // Object.entries(testData.analysisResult).forEach(([k, v]) => {

        //   const tmpKey = k.replace('analysis', '');
        //   if (analysis[tmpKey].ord < 4) {
        //     tmpChartData.push({
        //       category: analysis[tmpKey].label + " 독해",
        //       value1: v,
        //     })
        //   } else {
        //     tmpChartData.push({
        //       category: analysis[tmpKey].label,
        //       value1: v,
        //     })
        //   }
        // });
        // analysisChartData.value = tmpChartData;
        analysisChartData.value = _.sortBy(tmpChartData, 'ord');
        let tmpProblemTypeChartData = [];
        Object.entries(problemType).forEach(([k, v]) => {
            tmpProblemTypeChartData.push({
                category: v,
                value1: rs.problemTypeResult[k] < 0 ? 0 : rs.problemTypeResult[k],
            });
        });
        problemTypeChartData.value = tmpProblemTypeChartData;
        // console.log(_.isEmpty(globalStore.userInfo));
        if (_.isEmpty(globalStore.userInfo)) {
            globalStore.getUserInfo();
            // console.log(globalStore.getUserInfo());
        }
        user.value = globalStore.userInfo;
        rsData.value = rs;
        // }
    }
    // if (!props.isListItem && globalStore.loginRoot === 'growthplate') {
    //     requestGrowthplateFinish();
    // }
});

const movePg = (pg) => {
    router.push('/' + pg);
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};

const studyStart = async () => {
    /* KRT-1587 */
    const res = await zzApi.getUserMain2();
    if (res && res.status === 200) {
        const rs = res.data.data;
        let tmpMapTree = [];
        // let tmpStudy = { '01': [], '02': [] };
        rs.studyMain.forEach((element) => {
            // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
            tmpMapTree.push({
                // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
                examCode: element.examName,
                version: rs.exprVersion,
                // TODO: 변경해야함
                headerEtcCd02: element.areaCode === '01' ? '05' : '02',
                headerEtcCd01: element.passageClass,
                passageClass: element.passageClass,
                area: element.areaCode === '01' ? '문학' : '비문학',
                title: element.passageName,
                areaCode: element.areaCode,
                isDone: false,
                learningStatus: element.learningStatus,
                learningType: element.learningType,
                difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
                satOrder: element?.satOrder ? element?.satOrder : null,
                groupIndex: element?.groupIndex ? element?.groupIndex : null,
                level: element?.level,
                lesson: element?.lesson,
            });
        });
        studyStore.level = rs.level;
        studyStore.lesson = rs.lesson;
        studyStore.exprVersion = rs.exprVersion;
        studyStore.mapTree.exams = tmpMapTree;
        // studyStore.difficultyL = JSON.parse(rs.difficultyL);
        // studyStore.difficultyN = JSON.parse(rs.difficultyN);

        const fIndex = _.findIndex(rs.studyMain, function (o) {
            return o.examName === rs.currentStart.examName;
        });
        studyStore.process.examIdx = fIndex;
        if (rs.studyMain[fIndex].learningStatus === 'W') {
            studyStore.process.studyTree = 5082;
        }
        studyStore.process.problemOrd = 0;
        studyStore.process.exam = {
            // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
            examCode: rs.currentStart.examName,
            version: rs.exprVersion,
            // TODO: 변경해야함
            headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
            headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
            passageClass: rs.studyMain[fIndex].passageClass,
            area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
            title: rs.studyMain[fIndex].passageName,
            areaCode: rs.currentStart.areaCode,
            isDone: false,
            learningHistorySeq: rs.currentStart.learningHistorySeq,
            learningType: rs.currentStart.learningType,
            learningStatus: rs.studyMain[fIndex]?.learningStatus,
            difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
            satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
            groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
            level: rs.currentStart?.level,
            lesson: rs.currentStart?.lesson,
        };

        // postUserJson(JSON.stringify(studyStore.process), (rs) => {
        //   //
        // });

        if (rs.currentStart.learningType === 'SAT' || rs.currentStart.learningType === 'SAT_RESET') {
            return router.push('/sat');
        } else {
            return router.push('/corereading');
        }
    }

    // getUserMain((rs) => {
    //     let tmpMapTree = [];
    //     // let tmpStudy = { '01': [], '02': [] };
    //     rs.studyMain.forEach((element) => {
    //         // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
    //         tmpMapTree.push({
    //             // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
    //             examCode: element.examName,
    //             version: rs.exprVersion,
    //             // TODO: 변경해야함
    //             headerEtcCd02: element.areaCode === '01' ? '05' : '02',
    //             headerEtcCd01: element.passageClass,
    //             passageClass: element.passageClass,
    //             area: element.areaCode === '01' ? '문학' : '비문학',
    //             title: element.passageName,
    //             areaCode: element.areaCode,
    //             isDone: false,
    //             learningStatus: element.learningStatus,
    //             learningType: element.learningType,
    //             difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
    //             satOrder: element?.satOrder ? element?.satOrder : null,
    //             groupIndex: element?.groupIndex ? element?.groupIndex : null,
    //             level: element?.level,
    //             lesson: element?.lesson,
    //         });
    //     });
    //     studyStore.level = rs.level;
    //     studyStore.lesson = rs.lesson;
    //     studyStore.exprVersion = rs.exprVersion;
    //     studyStore.mapTree.exams = tmpMapTree;
    //     // studyStore.difficultyL = JSON.parse(rs.difficultyL);
    //     // studyStore.difficultyN = JSON.parse(rs.difficultyN);

    //     const fIndex = _.findIndex(rs.studyMain, function (o) {
    //         return o.examName === rs.currentStart.examName;
    //     });
    //     studyStore.process.examIdx = fIndex;
    //     if (rs.studyMain[fIndex].learningStatus === 'W') {
    //         studyStore.process.studyTree = 5082;
    //     }
    //     studyStore.process.problemOrd = 0;
    //     studyStore.process.exam = {
    //         // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
    //         examCode: rs.currentStart.examName,
    //         version: rs.exprVersion,
    //         // TODO: 변경해야함
    //         headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
    //         headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
    //         passageClass: rs.studyMain[fIndex].passageClass,
    //         area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
    //         title: rs.studyMain[fIndex].passageName,
    //         areaCode: rs.currentStart.areaCode,
    //         isDone: false,
    //         learningType: rs.currentStart.learningType,
    //         learningStatus: rs.studyMain[fIndex]?.learningStatus,
    //         difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
    //         satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
    //         groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
    //         level: rs.currentStart?.level,
    //         lesson: rs.currentStart?.lesson,
    //     };

    //     // postUserJson(JSON.stringify(studyStore.process), (rs) => {
    //     //   //
    //     // });

    //     if (rs.currentStart.learningType === 'SAT' || rs.currentStart.learningType === 'SAT_RESET') {
    //         return router.push('/sat');
    //     } else {
    //         return router.push('/corereading');
    //     }
    // });

    // if (studyStore.process.exam.learningType === 'SAT') {
    //   router.push('/sat');
    // } else {
    //   router.push(studyStore.process.studyTree === 5083 ? '/authenticreading' : studyStore.process.studyTree === 5084 ? '/vocabularylearning' : 'corereading');
    // }
};

const comSchoolAndGrade = computed(() => Comm.getStrSchoolAndGrade());
</script>

<style scoped lang="scss">
.report {
    width: 100%;
    height: calc(100vh - 7.3vmin);

    &__title {
        font-size: 2.2vw;
        line-height: 3.3vw;
        font-weight: bold;
    }

    &__calendar {
        margin-top: 2.67vmin;
        display: flex;
        line-height: 2.1vw;
        font-size: 1.3vw;
        align-items: center;
        color: $color_gray_600;
    }

    .top__info {
        // padding: 6.67vmin 19.17vmin;
        padding: 6.67vmin 10.17vmin;

        &__wrap {
            display: flex;
            justify-content: space-between;
        }
    }

    .chart__wrap {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 56.75vmin;
        height: 31.83vmin;
        background-color: white;
        // border-radius: 2.67vmin;
        @include border-radius(1.6vw);

        .chart__item {
            display: flex;
        }

        .chart__area {
            width: 25.58vmin;
            height: 12.75vmin;
        }
    }

    .chart__summary {
        display: inline-flex;
        align-items: center;
        color: $text_secondary;
        margin-left: 5.23vmin;
    }

    .hr {
        border: 10px solid $color_gray_100;
    }
}

.pd_lr_230 {
    // padding-left: 19.17vmin;
    // padding-right: 19.17vmin;
    padding-left: 10.17vmin;
    padding-right: 10.17vmin;
}

.pd__10 {
    padding: 0.83vmin !important;
}

.mg_top_46 {
    margin-top: 3.83vmin;
}

.mg_top_72 {
    margin-top: 6vmin;
}

.final__comment {
    padding: 1.67vmin;
    font-size: 1.4vw;
    line-height: 2.5vw;
    white-space: pre-line;
    margin-bottom: 6.67vmin;
}

.sub-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 3.33vmin;
}

.title {
    font-size: 1.8vw;
    line-height: 2.6vw;
    font-weight: 700;
    margin-bottom: 3vmin;
}

.summary_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc((100% / 3) - 1.67vmin);
    // width: 41.67vmin;
    height: 15.5vmin;
    padding: 3.33vmin;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    @include border-radius(0.8vw);
    background-color: #f7f7f7;
}

.summary-table {
    border-top: 1px solid #8e8e8e;
    border-bottom: 1px solid #8e8e8e;
    border-radius: 0px;

    thead {
        background-color: #ededed;
    }
}

.item-box {
    // display: flex;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    padding: 20px;
    font-size: 2vmin;
}

.q-table {
    font-size: 2vmin;

    th {
        background-color: $color_gray_100;
        font-size: 1.2vw;
        // padding: 2.3vmin 0 2vmin;
        height: 6.67vmin;
    }

    td {
        font-size: 1.3vw;
        line-height: 2.1vw;
        font-weight: 400;
        height: 8.5vmin;
        max-width: 200px;
        /* overflow: hidden;
    text-overflow: ellipsis; */
        white-space: normal;
    }
}

.btn {
    flex: 1;
    height: 8.17vmin;
    margin: 0 1vw;
    font-size: 1.2vw;
    font-weight: 700;
    border-radius: 1.33vmin;
    &__wrap {
        display: flex;
        padding: 0 5vw;
        justify-content: center;
    }
}

::v-deep {
    .q-btn__content {
        .block {
            font-weight: 700;
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.title__sub {
    margin: 3.33vmin 0;
    font-size: 1.6vw;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.help__content {
    font-weight: 500;
    font-size: 1.1vw;
    line-height: 1.85vw;
    margin-left: 1.33vmin;
}

.colum__chart__wrap {
    height: 50vmin;
    width: 100%;
    padding: 1.67vmin;
    background-color: $color_gray_100;

    .answer__box {
        width: 100%;
        display: grid;
        justify-items: end;
        font-weight: 500;

        &__wrap {
            display: inline-flex;
            align-items: center;
        }

        &__legend {
            width: 3.33vmin;
            height: 1.17vmin;
            background-color: #8e43f0;
            margin-right: 0.83vmin;
            border-bottom-right-radius: 50px;
            border-top-right-radius: 50px;
        }
    }
}

.question-mark {
    width: 2.1vw;
    height: 1.7vw;
    font-size: 1.5vw !important;
    align-items: flex-start;
}

.mark__list {
    li {
        font-size: 1.1vw;
        font-weight: 500;
        line-height: 1.85vw;
        word-break: keep-all;

        &:nth-of-type(n + 2) {
            margin-top: 0.67vmin;
        }
    }
}
</style>
